import { AssistantBase } from 'node_modules/@langchain/langgraph-sdk/dist/schema';

import { DEFAULT_ASSISTANT_NAME } from './constants';

export const checkIsSystemAssistant = (assistant?: AssistantBase) =>
  assistant?.metadata?.created_by === 'system';

export const getAssistantDisplayName = (assistant?: AssistantBase) =>
  checkIsSystemAssistant(assistant)
    ? DEFAULT_ASSISTANT_NAME
    : assistant?.name ?? '';

export const getAssistantNameError = ({
  assistantName,
  existingAssistantNames,
}: {
  assistantName?: string;
  existingAssistantNames?: string[];
}) => {
  if (!assistantName) return undefined;
  if (existingAssistantNames?.includes(assistantName)) {
    return 'An assistant with this name already exists';
  }

  if (assistantName.length === 0) {
    return 'Assistant name cannot be empty';
  }

  return undefined;
};

export const getNewAssistantName = (assistants: AssistantBase[]) => {
  // Get assistant names that match "New Assistant" or "New Assistant (number)" pattern
  const assistantNames = assistants.map((assistant) => assistant.name);

  // If "New Assistant" doesn't exist, return it as the preferred default name
  if (!assistantNames.includes('New Assistant')) {
    return 'New Assistant';
  }

  // Get names that match the numbered pattern
  const matchingNames = assistantNames.filter((name) =>
    name.match(/New Assistant \((\d+)\)/)
  );

  // Extract numbers from assistant names
  const usedNumbers = new Set<number>();
  matchingNames.forEach((name) => {
    const match = name.match(/New Assistant \((\d+)\)/);
    if (match) {
      usedNumbers.add(parseInt(match[1], 10));
    }
  });

  // Start with 1 and find the first available number
  let nextNumber = 1;
  while (usedNumbers.has(nextNumber)) {
    nextNumber++;
  }

  return `New Assistant (${nextNumber})`;
};
